import React from "react";
import { useNavigate } from 'react-router-dom';
import Popup from "../../../components/Popups/Popup";
import CreateItemView from '../../Items/Components/CreateItem';
import DataService from "../../../services/data.service";
import ItemRevisionModel from '../../../models/ItemRevisionModel';

interface PopupProps {
    show: boolean
    onHide: () => void
    itemTypeId: number
    itemTypeName: string
}

const CreateItemPopup: React.FC<PopupProps> = ({ show, onHide, itemTypeId, itemTypeName }) => {
    const navigate = useNavigate();

    function onItemCreated(itemId: number) {
        DataService
            .get<ItemRevisionModel[]>('api/v1/ItemRevisions/ByItem/' + itemId)
            .then(response => {
                navigate('/plm/items/itemrevision/' + response[0].id);
            })
    }

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Create new ' + itemTypeName} >
            <Popup.Body>
                <CreateItemView itemTypeId={itemTypeId} onItemCreated={onItemCreated} />
            </Popup.Body>
        </Popup>
    );
}
export default CreateItemPopup;